import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

// Backend redirects here with ?error=account_not_found when WSO2 authenticated
// the user but they have no ARMF onboarding profile. We must NOT auto-login in
// that case (it would loop straight back to WSO2); instead show a clear
// "account not found, sign up" screen.
const Login = () => {
  const { login } = useAuth();
  const [errorState, setErrorState] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");
    if (error) {
      setErrorState({ error, signup: params.get("signup") });
      return; // do NOT redirect, break the login loop
    }
    login();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (errorState) {
    const isNotFound = errorState.error === "account_not_found";
    const isUnavailable = errorState.error === "service_unavailable";
    return (
      <div className="d-flex align-items-center justify-content-center vh-100 bg-white">
        <div
          className="text-center p-5 rounded-4"
          style={{ maxWidth: 440, border: "1px solid #e2e8f0", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)" }}
        >
          <div style={{ fontSize: 44, marginBottom: 12 }}>
            {isNotFound ? "🔍" : isUnavailable ? "🛠️" : "⚠️"}
          </div>
          <h2 className="fs-4 fw-bold mb-2" style={{ color: "#0f172a" }}>
            {isNotFound
              ? "Account not found"
              : isUnavailable
                ? "Sign-in temporarily unavailable"
                : "Sign in failed"}
          </h2>
          <p className="text-muted mb-4" style={{ fontSize: 15 }}>
            {isNotFound
              ? "We couldn't find an ARMF account for you. Please create an account first, then sign in."
              : isUnavailable
                ? "We can't reach our verification service right now. This is on our side, please try again in a few minutes."
                : "Something went wrong while signing you in. Please try again."}
          </p>

          <div className="d-flex flex-column gap-2">
            {isNotFound && errorState.signup && (
              <a
                href={errorState.signup}
                className="btn text-white fw-medium py-2"
                style={{ background: "#1bbb6b", border: "none", borderRadius: 10 }}
              >
                Create an account
              </a>
            )}
            <button
              className="btn fw-medium py-2"
              onClick={() => {
                // Clear the error param so we don't re-trigger this screen.
                window.history.replaceState({}, "", "/login");
                login();
              }}
              style={{ border: "1px solid #e2e8f0", borderRadius: 10, background: "#fff", color: "#334155" }}
            >
              Try signing in again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-white">
      <div className="text-center">
        <div className="spinner-border text-success mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-muted">Redirecting to sign in...</p>
      </div>
    </div>
  );
};

export default Login;
